// src/config.js
// ─────────────────────────────────────────────────────────────────────────────
// All API keys are loaded from the .env file in the project root.
// To update a key: open .env, change the value, restart npm start.
// Never paste keys directly into this file.
// ─────────────────────────────────────────────────────────────────────────────

export const GROQ_API_KEY = process.env.REACT_APP_GROQ_API_KEY;
export const GROQ_MODEL = "llama-3.3-70b-versatile";

export const RESEND_API_KEY = process.env.REACT_APP_RESEND_API_KEY;
export const RESEND_FROM_EMAIL = process.env.REACT_APP_RESEND_FROM_EMAIL || "noreply@homiefixit.com";

export const AMAZON_AFFILIATE_TAG = process.env.REACT_APP_AMAZON_AFFILIATE_TAG;
